<template>
  <div class="main-bas">
    <div class="title-jibne">基本信息</div>
    <div class="main-forin">
      <div class="tou">
        <div><i class="el-icon-user"></i></div>
        <!-- <div class="xuigai">修改</div> -->
      </div>
      <div>
        <div>用户名:</div>
        <div>{{ realInformation.certName || userInfo.userName }}</div>
        <!-- <div  class="xuigaimima">修改密码</div> -->
      </div>
      <div>
        <div>账户ID:</div>
        <div>{{ userInfo.userId || userInfo.bossUserId }}</div>
      </div>
      <div>
        <div>手机号:</div>
        <div>{{ userInfo.phonenumber }}</div>
        <el-button
          v-if="userInfo.phonenumber"
          type="text"
          @click="dialogVisible2 = true"
          class="xuigaimimall"
          >修改手机号</el-button
        >
      </div>
      <div>
        <div>账户类型:</div>
        <div>无</div>
      </div>
      <div>
        <div>实名认证:</div>
        <div>
          {{ realInformation.certName ? realInformation.certName : '未认证' }}
        </div>
        <!-- <div class="xuigaimima">重新认证</div> -->
      </div>
      <div>
        <div @click="gosafef">会员类型:</div>
        <div>{{ userInfo.bossUserId ? '子用户' : '代理用户' }}</div>
      </div>
      <div>
        <el-button type="primary" @click="dialogVisible = true"
          >修改密码</el-button
        >
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="50%">
      <resetPwd />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="修改手机号" :visible.sync="dialogVisible2" width="50%">
      <el-form ref="formName2" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="手机号:" prop="ifmName">
          <el-input v-model="form.ifmName"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="form.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 63%"
          >
            <svg-icon
              slot="prefix"
              icon-class="validCode"
              class="el-input__icon input-icon"
            />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item>
        <el-form-item prop="verificationCode">
          <el-input
            v-model="form.verificationCode"
            auto-complete="off"
            placeholder="短信验证码"
            style="width: 63%"
          >
            <svg-icon
              slot="prefix"
              icon-class="validCode"
              class="el-input__icon input-icon"
            />
          </el-input>
          <div class="register-code">
            <el-button
              @click.native.prevent="getVerificationCode"
              :disabled="isDisabled"
            >
              {{ buttonText }}</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ifundUpd()">保存</el-button>

        <el-button @click="dialogVisible2 = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { updateUserProfile, userUpdate } from '@/api/user.js'
import { getCodeImg, getVerificationCode } from '@/api/login'

import resetPwd from './resetPwd'

export default {
  name: '',
  components: { resetPwd },
  mixins: [],
  props: {},
  data () {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        ifmName: '',
        code: '',
        uuid: '',
        verificationCode: ''
      },
      rules: {
        ifmName: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      },
      codeUrl: '',
      isDisabled: false, // 按钮是否禁用
      countdown: 60, // 倒计时时间
      buttonText: '获取验证码' // 按钮文本
    }
  },
  computed: {
    // 计算属性绑定到Vuex store中的userInfo
    userInfo () {
      return this.$store.state.userInfo.user
    },
    // 计算属性绑定到Vuex store中的userInfo
    realInformation () {
      return this.$store.state.realInformation
    }
  },
  watch: {},
  created () {
    this.getCode()
  },
  mounted () {},
  methods: {
    ifundUpd () {
      this.$refs.formName2.validate(valid => {
        if (valid) {
          this.form.userId = this.$store.state.userInfo.user.userId
          updateUserProfile(
            {
              userName: this.form.ifmName,
              phonenumber: this.form.ifmName
            },
            {
              code: this.form.verificationCode
            }
          ).then(res => {
            if (res.code == 200) {
              userUpdate({
                userId: this.$store.state.userInfo.user.userId,
                phone: this.form.ifmName
              }).then(res => {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })

                this.$store.dispatch('LogOut').then(() => {
                  this.$router.push({ path: '/login' })
                  window.location.reload()
                })
              })
            }
          })
        }
      })
    },
    gosafef () {
      console.log('---', this.$store.state.userInfo)
    },
    getCode () {
      getCodeImg().then(res => {
        this.captchaEnabled =
          res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.form.uuid = res.uuid
        }
      })
    },
    async getVerificationCode () {
      if (this.form.code && this.form.ifmName) {
        //         /sms/temp/{type}
        // String phone 手机号
        // String captchaUuid 图形验证码id
        // String captchaCode 图形验证码用户填写值
        // 这个是发送短信的接口，type固定值reg、login、dci，分别对应注册、登录、dci申领支付
        let upbadge = new FormData()
        upbadge.append('phone', this.form.ifmName)
        upbadge.append('captchaUuid', this.form.uuid)
        upbadge.append('captchaCode', this.form.code)
        const res = await getVerificationCode(upbadge, 'reg')
        if (res.code == 200) {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          })
          // 禁用按钮
          this.isDisabled = true
          // 启动倒计时
          const timer = setInterval(() => {
            this.countdown--
            this.buttonText = `${this.countdown}秒后重试`

            // 倒计时结束
            if (this.countdown <= 0) {
              clearInterval(timer) // 清除定时器
              this.isDisabled = false // 启用按钮
              this.buttonText = '获取验证码' // 恢复按钮文本
              this.countdown = 60 // 重置倒计时时间
            }
          }, 1000)
        }
        console.log('短信验证码--------', res)
      } else {
        this.$message({
          message: '请输入手机号和图形验证码',
          type: 'warning'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-bas {
  padding: 50px;
}
.title-jibne {
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.tou {
  margin-top: 80px;

  i {
    font-size: 125px;
  }
  .xuigai {
    font-size: 14px;
    color: #169bd5;
    writing-mode: vertical-lr;
    &:hover {
      cursor: pointer;
    }
  }
}

.main-forin {
  > div {
    display: flex;
    margin-top: 25px;
    :nth-child(1) {
      width: 100px;
    }
    .xuigaimima {
      margin-left: 50px;
      color: #169bd5;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.xuigaimimall {
  margin-left: 50px;
  color: #169bd5;
}
</style>
